define(['lodash', 'zepto', 'layout/util/layout'], function (_, $, /** layout.layout */ layout) {
    'use strict';
    layout.registerCustomMeasure('wysiwyg.viewer.components.inputs.Checkbox', function (id, measureMap, nodesMap) {
        const node = nodesMap[id];
        const hasLabel = $(node).data('hasLabel');
        if (!hasLabel) {
            return;
        }
        measureMap.height[id] = node.offsetHeight;
        measureMap.width[id] = node.offsetWidth;
    });
});
